import React from 'react'
import { MdCropSquare } from 'react-icons/md'
import cn from 'classnames'

import 'components/graph/controls/controls.less'
import 'components/graph/controls/select.less'

type SelectControlProps = {
  focus: {
    id?: string
    isNode: boolean
    isEdge: boolean
  }
  selected: {
    nodes: Record<string, unknown>
    edges: Record<string, unknown>
  }
  toggleSelectFocus: () => void
  isCreating: boolean
  isEditing: boolean
  control: string
}

const SelectControl = ({ focus, selected, toggleSelectFocus, isCreating, isEditing, control }: SelectControlProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    if (isCreating || isEditing) {
      return
    }
    toggleSelectFocus()
  }

  const focusId = focus.id
  let deselect = false
  if (focusId && focus.isNode && selected.nodes[focusId]) {
    deselect = true
  }
  if (focusId && focus.isEdge && selected.edges[focusId]) {
    deselect = true
  }
  const title = deselect ? 'Deselect' : 'Select'
  return (
    <div className={cn('control', 'select')} data-graph-type="control" title={`${title} ${control}`}>
      <a className={cn('icon', { disabled: isCreating || isEditing, deselect })} onClick={handleClick}>
        <MdCropSquare aria-hidden />
        <span className="sr-only">Select</span>
      </a>
    </div>
  )
}

export default SelectControl
